import { TextInput } from "@mantine/core";
import { useEditFieldNameMutation } from "../../hooks/mutations";
import classes from "./NameEdit.module.scss";

export default function NameEdit({ ruleId, id, defaultValue, onDone }) {
  const MIN_CHARS = 3;
  const { mutate: editFieldName } = useEditFieldNameMutation({ ruleId });
  const chars = Math.max(defaultValue?.length ?? 0, MIN_CHARS);

  return (
    <div className={classes.frame} style={{ width: `${chars}ch` }}>
      <TextInput
        defaultValue={defaultValue}
        autoFocus
        variant="unstyled"
        size="sm"
        classNames={{ input: classes.input }}
        onBlur={(ev) => {
          const name = ev.currentTarget.value;
          if (name !== defaultValue) {
            editFieldName({ id, name });
          }
          onDone?.();
        }}
        onKeyDown={(ev) => {
          if (ev.key === "Enter") ev.currentTarget.blur();
          if (ev.key === "Escape") onDone?.();
        }}
      />
    </div>
  );
}
